module.exports = __webpack_public_path__ + "img/noQuesTag.c2cce3fe.svg";